


<template>

</template>

<script>
export default {
  data() {
    return {}
  },
  created() {
    document.title = 'WeMeet'
    const data = {
      appKey: 'WX_MINI_WEMEET',
      expireInterval: 0,
      expireTime: 0,
      expireType: 0,
      isExpire: true,
      jumpWxa: {
        envVersion: process.env.NODE_ENV == 'production' ? 'release': 'trial',
        path: '/subPackage/meet/my/apply-for',
        query: 'show=true',
      },
    }
    var headerClientInfo = { language: 'CN', eventKey: 'WeMeet', appKey: 'WX_MINI_WEMEET' }
    const config = {
      method: 'post',
      url: `https://jos.wemeet.com/user/wx/generateScheme`,
      data,
      headers: {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      },
    }

    this.$http(config).then((res) => {
      console.log(res)
      window.location.href = res.data.value
    })
  },
}
</script>

<style>
</style>


